import { render, staticRenderFns } from "./rectification.vue?vue&type=template&id=3b5a2594"
import script from "./rectification.vue?vue&type=script&lang=js"
export * from "./rectification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports